<template>
  <div class="flex flex-col items-center w-full h-5/6 justify-center text-center gap-10 px-10">
    <template v-if="searchQuery">
      <img :src="magnifier" alt="magnifier picture">
      <span class="leading-loose text-gray-dark" v-html="noMatchText"/>
    </template>
    <template v-else>
      <slot/>
      <slot name="button"/>
    </template>
  </div>
</template>

<script>
import magnifier from '../../assets/images/magnifier.svg'

export default {
  name: 'ListSectionEmpty',

  props: {
    name: {
      type: String,
      default: ''
    },
    searchQuery: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      magnifier
    }
  },

  computed: {
    noMatchText() {
      return `No <span class="capitalize">${this.name}</span> found with name:<br/><span class="text-black">"${this.searchQuery}"</span>`
    }
  }
}
</script>
